module.exports = __webpack_public_path__ + "static/img/img_robot@2x.e4a97dcc.png";